module.exports = __webpack_public_path__ + "static/media/n_icon_tab_left.18508370.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_tab_left.png
// module id = 1817
// module chunks = 0 1